function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ConfirmYourAddressPopup from 'swag-client-common/components/popups/confirm-your-adress-popup';
import { variables } from 'swag-client-common/styles/variables-js';
function getButtonStyle(primaryColor) {
  return {
    backgroundColor: `${primaryColor} !important`,
    borderColor: `${primaryColor} !important`,
    color: `${variables.colorWhite} !important`
  };
}
const useStyles = makeStyles({
  button: ({
    primaryColor
  }) => _objectSpread({}, getButtonStyle(primaryColor), {
    '&:hover': _objectSpread({}, getButtonStyle(primaryColor), {
      opacity: 0.8
    })
  }),
  border: ({
    primaryColor
  }) => ({
    borderColor: primaryColor
  }),
  popup: ({
    primaryColor
  }) => ({
    '& svg': {
      backgroundColor: primaryColor
    }
  })
});
const GiveawayConfirmYourAddressPopup = ({
  primaryColor
}) => {
  const classes = useStyles({
    primaryColor
  });
  return /*#__PURE__*/React.createElement(ConfirmYourAddressPopup, {
    saveText: "Save & Submit",
    popupClassName: classes.popup,
    buttonClassName: classes.button,
    activeBorderClassName: classes.border
  });
};
export default GiveawayConfirmYourAddressPopup;